import { createRouter,createWebHashHistory,createWebHistory } from 'vue-router'
import LayoutDefault from "../layout/index.vue";

const routes = [
  {
    path:'/',
    name:'Index',
    component:LayoutDefault,
    redirect: "/",
    meta:{
      iconClass: "iconfont icon-home",
      title: "首页",
    },
    children: [
      {
        path: "/",
        component: () => import("../views/Index/index.vue"),
        name: "Index",
        meta: {
          iconClass: "iconfont icon-home",
          title: "首页",
        },
      },
      {
        path: "/Index/:DetailId",
        component: () => import("../views/XijiangNewsDetail/index.vue"),
        name: "IndexDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "首页",
        },
      },
      {
        path: "/About",
        component: () => import("../views/About/index.vue"),
        name: "About",
        meta: {
          iconClass: "iconfont icon-home",
          title: "关于西乳",
        },
      },
      {
        path: "/Strategy",
        component: () => import("../views/Strategy/index.vue"),
        name: "Strategy",
        meta: {
          iconClass: "iconfont icon-home",
          title: "西乳战略",
        },
      },
      {
        path: "/Product",
        component: () => import("../views/Product/index.vue"),
        name: "Product",
        meta: {
          iconClass: "iconfont icon-home",
          title: "产品中心",
        },
      },
      {
        path: "/Product/:DetailId",
        component: () => import("../views/ProductDetail/index.vue"),
        name: "ProductDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "产品详情",
        },
      },
      {
        path: "/News",
        component: () => import("../views/News/index.vue"),
        name: "News",
        meta: {
          iconClass: "iconfont icon-home",
          title: "西乳动态",
        },
      },
      {
        path: "/News/:DetailId",
        component: () => import("../views/XijiangNewsDetail/index.vue"),
        name: "NewsDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "西乳新闻详情",
        },
      },
      {
        path: "/ContactUs",
        component: () => import("../views/ContactUs/index.vue"),
        name: "ContactUs",
        meta: {
          iconClass: "iconfont icon-home",
          title: "联系我们",
        },
      },
      {
        path: "/XijiangNewsList",
        component: () => import("../views/XijiangNewsList/index.vue"),
        name: "XijiangNewsList",
        meta: {
          iconClass: "iconfont icon-home",
          title: "西乳新闻列表",
        },
      },
      {
        path: "/XijiangNewsList/:DetailId",
        component: () => import("../views/XijiangNewsDetail/index.vue"),
        name: "XijiangNewsDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "西乳新闻详情",
        },
      },
      {
        path: "/XijiangBulletinList",
        component: () => import("../views/XijiangBulletinList/index.vue"),
        name: "XijiangBulletinList",
        meta: {
          iconClass: "iconfont icon-home",
          title: "公告通知列表",
        },
      },
      {
        path: "/XijiangBulletinList/:DetailId",
        component: () => import("../views/XijiangBulletinDetail/index.vue"),
        name: "XijiangBulletinDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "公告通知详情",
        },
      },
      {
        path: "/XijiangPoliciesRegulationsList",
        component: () => import("../views/XijiangPoliciesRegulationsList/index.vue"),
        name: "XijiangPoliciesRegulationsList",
        meta: {
          iconClass: "iconfont icon-home",
          title: "政策法规列表",
        },
      },
      {
        path: "/XijiangPoliciesRegulationsList/:DetailId",
        component: () => import("../views/XijiangPoliciesRegulationsDetail/index.vue"),
        name: "XijiangPoliciesRegulationsDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "政策法规详情",
        },
      },
      {
        path: "/XijiangPartyBuildingCultureList",
        component: () => import("../views/XijiangPartyBuildingCultureList/index.vue"),
        name: "XijiangPartyBuildingCultureList",
        meta: {
          iconClass: "iconfont icon-home",
          title: "党建文化列表",
        },
      },
      {
        path: "/XijiangPartyBuildingCultureList/:DetailId",
        component: () => import("../views/XijiangPartyBuildingCultureDetail/index.vue"),
        name: "XijiangPartyBuildingCultureDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "党建文化详情",
        },
      },
      {
        path: "/Preview/:DetailId",
        component: () => import("../views/PreviewDetail/index.vue"),
        name: "PreviewDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "预览详情",
        },
      },
      {
        path: "/Search",
        component: () => import("../views/Search/index.vue"),
        name: "Search",
        meta: {
          iconClass: "iconfont icon-home",
          title: "全站搜索",
        },
      },
      {
        path: "/Search/SearchNewsDetail/:DetailId",
        component: () => import("../views/XijiangNewsDetail/index.vue"),
        name: "SearchXijiangNewsDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "全站搜索详情",
        },
      },
      {
        path: "/Search/SearchProductDetail/:DetailId",
        component: () => import("../views/ProductDetail/index.vue"),
        name: "SearchProductDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "全站搜索详情",
        },
      },

    ]
  }
]

const router = createRouter({
	//createWebHistory = 没有#号
	//createWebHashHistory = 有#号
	history: createWebHistory(),
	routes
})

export default router
